import {
  parseTaskDefinitionIds,
  serializeTaskDefinitionIds,
} from '@shared/tracker-task-definition-filter';

export { parseTaskDefinitionIds, serializeTaskDefinitionIds };

export function readTaskDefinitionIdsFromSearch(search: string): number[] | null {
  const params = new URLSearchParams(search);
  return parseTaskDefinitionIds(params.get('taskDefinitionIds'));
}

export function copyTaskDefinitionIdsToParams(
  target: URLSearchParams,
  sourceSearch: string,
): void {
  const params = new URLSearchParams(sourceSearch);
  if (params.has('taskDefinitionIds')) {
    target.set('taskDefinitionIds', params.get('taskDefinitionIds') ?? '');
  }
}

export function trackerApiQueryString(taskDefinitionIdsParam: string | null): string {
  if (taskDefinitionIdsParam === null) {
    return '';
  }
  const parsed = parseTaskDefinitionIds(taskDefinitionIdsParam);
  if (parsed === null) {
    return '';
  }
  if (parsed.length === 0) {
    return '?taskDefinitionIds=';
  }
  return `?taskDefinitionIds=${encodeURIComponent(serializeTaskDefinitionIds(parsed))}`;
}

export function appendTaskDefinitionIds(
  params: URLSearchParams,
  selectedIds: number[] | null,
  allDefinitionIds: number[],
): void {
  params.delete('taskDefinitionIds');
  if (selectedIds === null) {
    return;
  }
  const allSorted = [...allDefinitionIds].sort((a, b) => a - b);
  const selectedSorted = [...selectedIds].sort((a, b) => a - b);
  if (selectedSorted.length === 0) {
    params.set('taskDefinitionIds', '');
    return;
  }
  const isAllSelected =
    allSorted.length > 0
    && allSorted.length === selectedSorted.length
    && allSorted.every((id, index) => id === selectedSorted[index]);
  if (!isAllSelected) {
    params.set('taskDefinitionIds', serializeTaskDefinitionIds(selectedSorted));
  }
}
